import PersonRoundedIcon from "@mui/icons-material/PersonRounded";

export const person = (props) => {
  return <PersonRoundedIcon {...props} />;
};
